export function getCompanyChurnedCode(err: unknown): string | undefined {
  const data = (err as {response?: {data?: unknown}} | undefined)?.response?.data;
  /**
   * `Object.prototype.toString` plutôt que `instanceof ArrayBuffer` : un
   * ArrayBuffer produit dans un autre realm (ex. `iframe`, `Window` distinct)
   * peut échouer l'instanceof sans échouer ce check.
   */
  if (Object.prototype.toString.call(data) === "[object ArrayBuffer]") {
    try {
      return (JSON.parse(new TextDecoder().decode(data as ArrayBuffer)) as {code?: string})?.code;
    } catch {
      return undefined;
    }
  }
  return (data as {code?: string} | undefined)?.code;
}

export function isCompanyChurnedError(err: unknown, status: number | undefined): boolean {
  return status === 403 && getCompanyChurnedCode(err) === "COMPANY_CHURNED";
}
